/**
 * Jedna sekcija u modalu: naslov + opis levo, kontrola desno (ili ispod ako je wide).
 */

import React from 'react';

export default function PreferenceSection({
  title,
  description,
  wide,
  children,
  classPrefix = 'ap',
}) {
  return (
    <div className={`${classPrefix}-uio-section${wide ? ` ${classPrefix}-uio-section--wide` : ''}`}>
      <div className={`${classPrefix}-uio-section-info`}>
        <h3 className={`${classPrefix}-uio-section-title`}>{title}</h3>
        {description && <p className={`${classPrefix}-uio-section-desc`}>{description}</p>}
      </div>
      <div className={`${classPrefix}-uio-section-control`}>{children}</div>
    </div>
  );
}
